export default __webpack_public_path__ + "static/media/close.bbdb13f6.svg";